import { useState } from "react";

import { Link } from "react-router-dom";

const Header = ({ color = "#941F1F" }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header aria-label="Site Header" style={{ backgroundColor: color }}>
      <div class="mx-auto flex h-16 max-w-screen-xl items-center gap-4 ml-4 pr-4 ">
        <Link class=" text-white block" to={"/"}>
          <span class="sr-only">Home</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="78.37"
            height="80"
            viewBox="0 0 78.37 19.64"
            className="mb-6"
            fill="#FFFFFF"
          >
            <path
              class="cls-1"
              d="m78.37,0c.53,5.02,0,13.83.18,19.64.23.84-1.24-.02-1.28.55-.06,7.93.12,14.97,0,21.47,1.49.38.76,1.94,1.1,3.3-13.74-.05-23.71-.18-36.81-.18H.18v-2.39c-.26-.81,1.1,0,1.1-.55.09-7.64.25-12.92.18-21.66.22-1.01-1.45-.14-1.46-.92C.41,13.32.07,6.62.18.37,24.95,0,57.11.21,78.37,0Zm-35.71.73c-12.67-.02-27.89.18-41.93.37.03,5.53.02,11.19,0,17.07,31.93.39,51,.34,77.28.18-.24-7.49.12-9.97-.18-17.44-13.54.1-23.66-.16-35.16-.18ZM2.2,19.64c-.43,7.67-.03,14.59-.18,22.21,7.61.5,13.07-.14,20.14,0-.09-5.48.17-10.68,0-14.87.03-.52-1.13.15-1.1-.37,1.03-3.15,5.2-2.82,9.34-2.75,4.22.07,7.68-.71,8.97,2.75-.13.42-1.04.05-.92.73-.07,4.44.03,10.2,0,14.5,5.74.43,11.12-.01,15.93.37.57-3,.2-7.15.37-9.91,1.65-.26,3.58-.65,5.13.18,0,3.74-.27,6.32,0,9.73,5.56-.12,11.6.24,16.85-.18-.22-7.57.44-15.61-.37-22.02-.23,0-.25-.24-.55-.18-1.06,1.93.33,6.33-.73,8.26-.73-1.7-5.3-.99-6.41-.18-.34-1.43-3.1-.44-4.58-.73-.66,0-.04,1.3-.92,1.1-.72.11.05-1.27-.73-1.1h-4.39c-.46.33.4,1.09-.73.92-.44-1.52-3.18-.73-4.94-.92-.47.08.19,1.29-.73.92-.72.17-.13-.97-.55-1.1-1.26.17-3.36.39-4.58,0,0,.56.11,1.21-.55,1.1-.63.02-.11-1.12-.73-1.1-.89.38-3.27.03-4.39.18-.47.08.19,1.29-.73.92-.06-2.08.04-5.59,0-8.26-6.29.08-13.25-.04-19.78,0,.07,2.84.34,5.49-.18,8.08-.6.06-.5-.58-.91-1.1-.97.12-2.57-.08-4.03,0-.57.16-.14,1.33-1.28.92-.35-.02.28-.68-.18-.92h-4.58c-.15.58-.38,1.09-1.1,1.1v-1.28c-1.1.3-2.66.15-4.03.18-.47.08.19,1.29-.73.92-.41-2.2.43-5.67-.18-8.08h-.92Zm1.65,1.65c.6.38,1.17.32,1.83,0-.12-.68-.52-1.08-.73-1.65-1.11-.2-1.18.65-1.1,1.65Zm2.38.18c.48.19,1.12.22,1.83.18.4-.44.48-1.39.18-2.02h-2.38c-.19.93.42,1.05.37,1.84Zm2.93.18h4.58c.25-.48.22-1.25.37-1.84-1.63-.17-6.41-1.09-4.94,1.84Zm5.68-.18c1.25.34,3.55.18,4.58.18.4-.44.48-1.39.18-2.02-1.7.32-5.81-1-4.76,1.84Zm26,.37c1.6-.11,3.64.23,4.94-.18.32-.62-.12-.94,0-1.84-1.51.18-6.4-1.14-4.94,2.02Zm5.86,0h4.76c-.19-.85.34-1.59,0-2.02h-4.94c.06.67-.16,1.62.18,2.02Zm5.68,0h4.58c.23-.67.2-1.2,0-2.02-1.79.67-5.48-1.34-4.58,2.02Zm5.68,0h4.94c-.13-.8.31-1.03.18-1.84-2.16.02-6.21-1.27-5.13,1.84Zm5.86,0c1.85-.1,2.79,0,4.76,0,.03-.58.43-1.35,0-1.84-1.02-.25-3.48.31-4.76-.18-.28.38-.28,1.64,0,2.02Zm5.68,0h2.75c.36-.56.75-1.08.92-1.84-1.32.06-5-.91-3.66,1.84Zm3.66-.18c.3.31,1.08.15,1.65.18v-1.84c-1.04-.5-1.4.8-1.65,1.65ZM4.03,26.06c1.57-.09,2.54.13,3.66-.18-.21-1.5-1.09-2.33-1.65-3.49-2.77-.99-2.39,2.11-2.01,3.67Zm2.93-3.49c.39.71.47,1.73,1.28,2.02v-2.2c-.49,0-1.05-.07-1.28.18Zm2.01,0c0,1.16.07,2.4-.18,3.3,1.33.38,3.32.1,4.94.18.46-1.32.34-2.35,0-3.67-1.68.31-3.17-.28-4.76.18Zm5.86,0c-.23.98-.08,1.86-.18,3.3,1.24.41,3.22.08,4.76.18.36-1.23.45-2.24.18-3.49-1.38-.04-3.75-.12-4.76,0Zm25.82.18c.15,1.34,0,2.34.18,3.3,1.24.41,3.22.08,4.76.18.35-.94.12-2.45.18-3.67-1.92.21-3.89-.42-5.13.18Zm5.86,3.49h4.94v-3.67h-4.94v3.67Zm5.86,0c1.48-.11,3.4.22,4.58-.18.36-1.19.11-2.48,0-3.49-2.15-.06-2.69.26-4.58,0-.3.85-.3,2.83,0,3.67Zm5.68-3.67c-.4.89-.08,2.49-.18,3.67h5.13v-3.67c-1.69.31-3.18.07-4.94,0Zm5.68,3.67h4.76c.3-.85.3-2.83,0-3.67-1.49.41-3.46.03-4.58,0-.4.89-.08,2.49-.18,3.67Zm5.86,0c1.54-.41,1.51-2.4,2.2-3.67-2.99-.74-2.49,1.85-2.2,3.67Zm3.11-3.49c-.54,1.17-1.42,2-1.65,3.49h3.66c.24-1.29-.04-2.36,0-3.67-.75-.02-1.15.32-2.01.18Zm-49.62,3.85v4.22h6.96c.59-1.82.03-4.09.37-5.51-2.56-.32-6.37-.59-7.32,1.29Zm8.06-1.29c-.07,1.24-.42,3.85,0,5.51,2.14-.11,4.75.23,6.59-.18,1.42-4.57-2.41-6.37-6.59-5.32Zm-7.87,6.24c-.38,3.67-.12,8.91-.18,12.3,2.99.04,4.54.12,6.96,0,.15-3.9.24-7.65.18-12.11-2.14-.02-4.16-.09-6.96-.18Zm7.87.18c-.25,2.83-.17,7.96-.18,12.11,2.2.13,4.26.28,6.78,0-.08-4.01.25-9.19,0-12.11h-6.59ZM2.01,42.76v.73c4.3.66,10.74.37,15.56.37,1.8,0,4.2.53,4.58-.55v-.37c-7.59-.81-13.44-.04-20.14-.18Zm36.44,0c-.4.38.09.52,0,1.1,3.6.33,8.77.18,12.63.18,1.23,0,3.25.58,3.48-.92-5-.98-10.5-.22-16.11-.37Zm21.42,1.1c3.73.35,8.73.18,13,.18,1.3,0,3.31.58,3.85-.73-4.58-1.09-10.19-.25-16.85-.55v1.1Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m60.25,30.28v.92c-1.65,0-4.21-.08-5.86,0,.02-.26.03-.52-.18-.55,1.6-1.21,4.33-.42,6.04-.37Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m47.98,31.02c-.55.78-2.88.25-3.3.18.2-1.12,2.83-.87,3.3-.18Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m14.83,31.02c-.5,1.14-2.52-.4-3.66.55,0-1.36,2.93-1.05,3.66-.55Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m69.95,31.57c-.94-.05-3.43.43-3.85-.37.56-.69,3.83-1.09,3.85.37Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m47.61,32.12c.28,1.47-.08,2.51,0,4.4.39.4,1.19.4.92,1.47-.99.04-3.53.13-4.76-.18-.34-.39-.03-1.25.73-1.1.35-1.47.12-2.86,0-4.04.75-.83,1.75-.61,3.11-.55Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m14.65,32.67c.19,2.02-.77,3.49.73,4.4v1.1c-2.33-.15-2.76.11-4.94-.37-.02-.64.16-1.07.91-.92v-4.22c.77-.66,2.52-.75,3.3,0Z"
              fill="currentColor"
            />
            <path
              class="cls-1"
              d="m69.58,32.67c.08,1.43-.33,2.37-.18,3.85.6.13.97.5,1.1,1.1-.98.75-4.12.25-5.13.37-.1-.89.5-1.09.92-1.47v-3.67c.66-.63,2.47-.75,3.3-.18Z"
              fill="currentColor"
            />
          </svg>
        </Link>
        <Link
          to={"/"}
          className="text-white font-roboto font-bold text-2xl hidden md:block mr-20"
        >
          Kulturverein Küsterscheune
        </Link>

        <div class="flex flex-1 items-center justify-end md:justify-between">
          <nav aria-label="Site Nav" class="hidden md:block">
            <ul class="flex items-center gap-6 text-md text-white font-roboto ">
              <li>
                <Link
                  to={"/veranstaltungen"}
                  className="hover:bg-white hover:text-black hover:rounded-md p-2.5 "
                >
                  Veranstaltungen
                </Link>
              </li>

              <li>
                <Link
                  to={"/buecherei"}
                  className="hover:bg-white hover:text-black hover:rounded-md p-2.5"
                >
                  Bücherei
                </Link>
              </li>

              <li>
                <Link
                  to={"/apfelsaftpressen"}
                  className="hover:bg-white hover:text-black hover:rounded-md p-2.5"
                >
                  Apfelsaftpressen
                </Link>
              </li>

              <li>
                <Link
                  to={"/kulturstationen"}
                  className="hover:bg-white hover:text-black hover:rounded-md p-2.5"
                >
                  Kulturstationen
                </Link>
              </li>
              <li>
                <Link
                  to={"/verein"}
                  className="hover:bg-white hover:text-black hover:rounded-md p-2.5"
                >
                  Verein
                </Link>
              </li>
            </ul>
          </nav>

          <button
            class="block rounded bg-gray-100 p-2.5 text-gray-600 transition hover:text-gray-600/75 md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span class="sr-only">Toggle menu</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            {isOpen && (
              <div
                class="absolute right-0 z-10 mt-4 w-56 origin-top-right rounded-md border border-gray-100  shadow-lg font-roboto text-white "
                style={{ backgroundColor: color }}
                role="menu"
              >
                <div class="p-2">
                  <Link
                    to={"/veranstaltungen"}
                    class="block rounded-lg px-4 py-2 text-sm  hover:bg-gray-50 hover:text-gray-700"
                    role="menuitem"
                  >
                    Veranstaltungen
                  </Link>

                  <Link
                    to={"/buecherei"}
                    class="block rounded-lg px-4 py-2 text-sm  hover:bg-gray-50 hover:text-gray-700"
                    role="menuitem"
                  >
                    Bücherei
                  </Link>

                  <Link
                    to={"/apfelsaftpressen"}
                    class="block rounded-lg px-4 py-2 text-sm  hover:bg-gray-50 hover:text-gray-700"
                    role="menuitem"
                  >
                    Apfelsaftpressen
                  </Link>

                  <Link
                    to={"/kulturstationen"}
                    class="block rounded-lg px-4 py-2 text-sm  hover:bg-gray-50 hover:text-gray-700"
                    role="menuitem"
                  >
                    Kulturstationen
                  </Link>
                  <Link
                    to={"/verein"}
                    class="block rounded-lg px-4 py-2 text-sm  hover:bg-gray-50 hover:text-gray-700"
                    role="menuitem"
                  >
                    Verein
                  </Link>
                </div>
              </div>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
